import DotPagination from './DotPagination';
export default DotPagination;
